// extracted by mini-css-extract-plugin
export default {"overlay":"GameOverOverlay_overlay__NdW0M"};